import { makeApi } from "./callApi";

export class ProductApi {
  static async getProductsByMerchantId(merchantId) {
    const response = await makeApi(`/product/list/merchant/${merchantId}`, "GET");
    return response.data;
  }

  static async getProductsByDisplayCategoryId(displayCategoryId) {
    const response = await makeApi(
      `/product/list/display-category/${displayCategoryId}`,
      "GET"
    );
    return response.data;
  }

  static async filterProducts(filter) {
    const response = await makeApi(`/product/list/filter`, "POST", filter);
    return response.data;
  }

  static async getHighlightedProducts(type) {
    const response = await makeApi(`/highlighted-product/filter?type=${type}`, "GET");
    return response.data;
  }
}
